// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1Qf-M","log":"ModalInventoryLogs_log__1CDdT","date":"ModalInventoryLogs_date__3qejH","userName":"ModalInventoryLogs_userName__12p_G"};